import React, { useState } from 'react';
import { useVans ,useDeleteVan} from './vans.hooks';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
  Paper, TableContainer, Typography, Pagination,
  CircularProgress, Box, TextField, Stack, Divider, Button, Tooltip
} from '@mui/material';
import { Link } from 'react-router-dom';
import { constants } from '../../constants';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import ModeEditOutlineRoundedIcon from '@mui/icons-material/ModeEditOutlineRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
export default function ManageVansPage() {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    name: '',
    username: '',
  });
  const [tempFilters, setTempFilters] = useState(filters); // temporary inputs
  const [page, setPage] = useState(1);
  const perPage = constants.PERPAGE;

  const { data, isLoading, isError, error } = useVans({ filters, page, perPage });
  const deleteMutation = useDeleteVan();


  const handleInputChange = (e) => {
    setTempFilters({ ...tempFilters, [e.target.name]: e.target.value });
  };


  const handleDelete = (id) => {
    if (!window.confirm('Are you sure you want to delete this van?')) return;

    deleteMutation.mutate(id, {
      onSuccess: () => {
        dispatch(showAlert({
          severity: 'success',
          title: 'Van deleted successfully.',
        }));
      },
      onError: (err) => {
        dispatch(showAlert({
          severity: 'error',
          title: err?.response?.data?.message || 'Failed to delete van.',
        }));
      },
    });
  };

  if (isLoading) {
    return (
      <Box textAlign="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    dispatch(showAlert({
      severity: 'error',
      title: error?.response?.data?.message || 'Error fetching vans.',
    }));
    return null;
  }

  return (
    <Paper sx={{ p: 3, mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Manage Vans
      </Typography>

      {/* Filters */}
      <Box sx={{ my: 2 }}>
        
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="flex-end">
          <TextField
            fullWidth
            name="name"
            label="Filter by Name"
            value={tempFilters.name}
            onChange={handleInputChange}
          />
          <TextField
            fullWidth
            name="username"
            label="Filter by Username"
            value={tempFilters.username}
            onChange={handleInputChange}
          />
          <Button
            variant="contained"
            onClick={() => {
              setFilters({ ...tempFilters });
              setPage(1);
            }}
            sx={{ height: '56px' }} // match TextField height
          >
            Apply Filter
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setTempFilters({ name: '', username: '' });
              setFilters({ name: '', username: '' });
              setPage(1);
            }}
            sx={{ height: '56px' }}
          >
            Reset
          </Button>
        </Stack>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Table */}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Username</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {data?.data?.length > 0 ? (
  data.data.map((van) => (
              <TableRow key={van.id}>
                <TableCell>{van.id}</TableCell>
                <TableCell>{van.name}</TableCell>
                <TableCell>{van.username}</TableCell>
                <TableCell>
                    <Link to={`/vans/edit/${van.id}`}>
                      <Tooltip title="Edit">
                        <ModeEditOutlineRoundedIcon sx={{ verticalAlign: 'middle', mr: 1, color: 'primary.main' }} />
                      </Tooltip>
                    </Link>
                    <Tooltip title="Delete">
                      <Button
                        color="error"
                        onClick={() => handleDelete(van.id)}
                        sx={{ minWidth: 0, p: 1 }}
                      >
                        <DeleteRoundedIcon />
</Button>
                    </Tooltip>
                </TableCell>
              </TableRow>
  ))
) : (
  <TableRow>
    <TableCell colSpan={4} align="center">
      No records found.
    </TableCell>
  </TableRow>
)}
          </TableBody>
        </Table>
      </TableContainer>


      {/* Pagination */}
      {data?.data?.length > 0 && (
      <Box mt={3} display="flex" justifyContent="center">
        <Pagination
          count={data?.last_page || 1}
          page={page}
          onChange={(e, value) => setPage(value)}
          color="primary"
        />
      </Box>
    )}
    </Paper>
  );
}
